import { useRecoilValue } from "recoil";
import Header from "../components/Header";
import { userData } from "../recoil/atom/userData";

export const Profile = () => {
    const user = useRecoilValue(userData)

    return (
        <div className="dark">
            <Header />
            <section className="dark:bg-gray-900 min-h-screen">
                <div className="flex items-center justify-center ">
                    <div className="bg-[#1d2637] shadow-lg rounded-2xl p-8 max-w-4xl w-full">
                        <h2 className="text-2xl text-white font-semibold mb-6 text-center">
                            Business Details
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="text-white p-4">
                                <h4 className="text-gray-300">Business Name</h4>
                                <p className="font-semibold">{user?.businessName}</p>
                            </div>
                            <div className="text-white p-4">
                                <h4 className="text-gray-300">Whatsapp Number</h4>
                                <p className="font-semibold">{user?.whatsAppNumber}</p>
                            </div>
                            <div className="text-white p-4">
                                <h4 className="text-gray-300">OEM Name</h4>
                                <p className="font-semibold">{user?.oemName}</p>
                            </div>
                            <div className="text-white p-4">
                                <h4 className="text-gray-300">State</h4>
                                <p className="font-semibold">{user?.businessState}</p>
                            </div>
                        </div>
                    </div>
                </div>
               
            </section>

        </div>
    );
};